module.exports = __webpack_public_path__ + "img/telegram.dd1d2f70.svg";